export default {
  EveryDay: 16,
  OnceAWeek: 17,
  Infrequently: 19,
  Frequently: 20,
  AFewHoursDaily: 21,
};
